import { ObjectSchema, string, mixed, object, InferType, number } from 'yup';

import { ExternalVerificationSource } from '@/types/externalVerification';
import { InsurancePolicy } from '@/types/insurancePolicy';
import { Person } from '@/types/person';

export const runVobSchema: ObjectSchema<
  Pick<Person, 'first_name' | 'last_name' | 'birthday'> &
    Pick<
      InsurancePolicy,
      | 'carrier'
      | 'subscriber_id'
      | 'policyholder_first_name'
      | 'policyholder_last_name'
      | 'policyholder_dob'
    > & {
      verification_source: ExternalVerificationSource;
      service_code: string;
    }
> = object({
  first_name: string().trim().required().label('First Name'),
  last_name: string().trim().required().label('Last Name'),
  birthday: string().trim().required().label('Patient DOB'),
  carrier: string().trim().required().label('Carrier'),
  subscriber_id: string().required().label('Subscriber ID'),
  policyholder_first_name: string().nullable(),
  policyholder_last_name: string().nullable(),
  policyholder_dob: string().nullable(),
  verification_source: mixed<ExternalVerificationSource>()
    .oneOf(Object.values(ExternalVerificationSource))
    .required(),
  service_code: string().trim().required()
});

export type RunVOBFormValues = InferType<typeof runVobSchema>;

export const insuranceVobSchema: ObjectSchema<
  {
    vob_notes?: string;
    estimated_monthly_cost?: number | null;
    estimated_initial_month_cost?: number | null;
  } & Pick<InsurancePolicy, 'plan_end_date' | 'priority_type'>
> = object({
  vob_notes: string().optional(),
  priority_type: string().nullable(),
  plan_end_date: string().nullable(),
  estimated_monthly_cost: number().required('Estimated Monthly Cost is required'),
  estimated_initial_month_cost: number().nullable()
});

export type InsuranceVOBFormValues = InferType<typeof insuranceVobSchema>;

export const verificationSourceOptions = [
  { value: ExternalVerificationSource.FRONTRUNNER, label: 'FrontRunner' },
  { value: ExternalVerificationSource.STEDI, label: 'Stedi' }
];
